// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"ee982b68","97":"fc29a7d3","185":"6208cc85","975":"1fe7f1c4"}[chunkId] + ".css";
};